export default name => (!name ? name : name.replace(/_/g, ' '));
